<template>
    <input-icon icon_name="search" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import input_icon from './input_icon.vue';
export default {
  components: {
    'input-icon': input_icon,
  },
  props: {
    error: {
      type: Boolean,
    },
  },
  computed: {
    invalid() {
      return this.error ? 'form__error' : '';
    },
  },
};
</script>
